(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name cycle.factory:AdminSnapFactory
     *
     * @description
     *
     */
    angular
        .module('snap')
        .factory('AdminSnapFactory', AdminSnapFactory);

    function AdminSnapFactory() {

    	//----declare DTOs------
    	//search cycle object
    	function CycleSearchDTO(){
    		this.cycleList =[];
    		this.nextRecordsMonthFrom= null;
    		this.nextRecordsMonthTo= null;
    		this.nextRecordsCrewGroupCode= null;
    		this.nextRecordsCrewGroups = null;
        }

    	//grid view cycle object
    	function SnapDTO(){
    		this.snapName = null;
    		this.cycle = null;
    	}

    	//newly added Cycle object
    	function SnapSaveRequestDTO(){
    		this.cycleId= null;
    		this.snapVersionName= null;
    		this.rosterState = null;
    	}

    	//cycle delete request object
    	function CycleDeleteRequestDTO(){
    		this.cycleId = null;
    		this.version= null;
    	}

    	function ScoreSnapRequestDTO(){
    		this.cycleId = null;
    		this.crewType = null;
    		this.snapShotVersion = null;
    		this.scoreName = null;
    	}

      function RestoreGridRequestDTO(){
        this.cycleId = null;
        this.crewType = null;
        this.snapshotScoreId = null;
      }


        //----Define Function --------
    	//getter and setters of Cycle Search DTO
    	function GetFormattedCycleSearchDTO(searchResponce){
    		var cycleSearchDTO = new CycleSearchDTO();
    		if(!!searchResponce.cycleList && searchResponce.cycleList.length>0){
    			for(var i=0;i<searchResponce.cycleList.length;i++){
    				var cycleDTO = new CycleDTO();
    				cycleDTO.cycleId = searchResponce.cycleList[i].cycleId;
    				cycleDTO.version = searchResponce.cycleList[i].version;
    				cycleDTO.cycleName = searchResponce.cycleList[i].cycleName;
    				cycleDTO.dateFrom = searchResponce.cycleList[i].dateFrom;
    				cycleDTO.dateTo =searchResponce.cycleList[i].dateTo;
    				cycleDTO.crewGroupCode = searchResponce.cycleList[i].crewGroupCode;
    				cycleSearchDTO.cycleList.push(cycleDTO) ;
    			}
    		}
    		cycleSearchDTO.nextRecordsMonthFrom = searchResponce.nextRecordsMonthFrom;
    		cycleSearchDTO.nextRecordsMonthTo = searchResponce.nextRecordsMonthTo;
    		cycleSearchDTO.nextRecordsCrewGroupCode = searchResponce.nextRecordsCrewGroupCode;
    		cycleSearchDTO.nextRecordsCrewGroups = searchResponce.crewGroups;
    		return cycleSearchDTO;
    	}

    	function GetCycleSearchDTO(){
    		return new CycleSearchDTO();
    	}

    	//getter and setter of Cycle DTO
    	function GetSnapDTO(){
    		return new SnapDTO();
    	}

    	function GetSnapScoreRequest(){
    		return new ScoreSnapRequestDTO();
    	}

      function GetRestoreGridRequest(){
        return new RestoreGridRequestDTO();
      }

    	//getter and setter of Cycle Save Request
    	function GetFormattedSnapSaveRequest(newCycle){
    		var cycleSaveReq = new SnapSaveRequestDTO();
    		cycleSaveReq.cycleId = newCycle.cycle;
    		cycleSaveReq.snapVersionName = newCycle.snapName;
    		cycleSaveReq.rosterState = "MANUAL";
        cycleSaveReq.uiRequest = true;
    		return cycleSaveReq;
    	}

    	function GetCycleSaveRequest(){
    		return new CycleSaveRequestDTO();
    	}

    	//getter and setter of Delete Request DTO
    	function GetCycleDeleteRequestDTO(){
    		return new CycleDeleteRequestDTO();
    	}

    	function GetFormattedCycleDeleteRequestDTO(cycleDTO){
    		var cycleDeleteReq = new CycleDeleteRequestDTO();
    		cycleDeleteReq.cycleId = cycleDTO.cycleId;
    		cycleDeleteReq.version = cycleDTO.version;
    		return cycleDeleteReq;
    	}


        //map services to return
        return {
        	getFormattedCycleSearchDTO : GetFormattedCycleSearchDTO,
        	getCycleSearchDTO : GetCycleSearchDTO,
        	getSnapDTO : GetSnapDTO,
        	getFormattedSnapSaveRequest: GetFormattedSnapSaveRequest,
        	getCycleSaveRequest : GetCycleSaveRequest,
        	getSnapScoreRequest : GetSnapScoreRequest,
        	getRestoreGridRequest : GetRestoreGridRequest
        }

    }
})();
